// extracted by mini-css-extract-plugin
export default {"tooltip":"BasicTooltip_tooltip__PtlTv","tooltipArrow":"BasicTooltip_tooltipArrow__80uq2"};